module.exports = __webpack_public_path__ + "static/media/card.2e228cb1.png";